import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { IndexedDbService } from '../services/indexed-dbservice.service';

export const authgaurdGuard: CanActivateFn = async (route, state) => {
  const router = inject(Router);
  const dbService = inject(IndexedDbService);

  try {
    const userData = await dbService.getData('userInfo');

    if (userData) {
      return true;
    } else {
      router.navigate(['/flight']);
      return false;
    }
  } catch (error) {
    console.error('Error reading IndexedDB', error);
    router.navigate(['/flight']);
    return false;
  }
};
